module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACuBAMAAAB+XC0hAAAAGFBMVEX/zQAAMIfIEC7KysqFG0t/fkTEETDWDignx3fYAAAA8UlEQVR42u3dS21CYRgA0T+pggYHxUDfFVAcEBSQYIAF9llcBbPiSzhHwTiY9TXSel8DvciStZFVyCpkFbIKWYWsQlYhq5BVyCpkFbIKWYWsQlYhq5BVyCpkFbIKWYWsQlYhq5BVyCpkFbIKWYWsQlYhq5BVyCpkFbIKWYWsQlYhq3ierJ/TQMf18TrQTpasjaxCViGrkFXIKmQVsgpZhaxCViGrkFXIKmQVsgpZhaxCViGrkFXIKmQ91G59Hwb6X3+3ga7r9zLQeX2+DbSXJWsjq5BVyCpkFbIKWYWsQlYhq5BVyCpkFbIKWQ+1H7qCuQM9Y6nhs180YQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/flag_rect_big/44.png
// module id = 2/ur
// module chunks = 1